export default __webpack_public_path__ + "code_repos_logo.5d8b497e.png";